"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabMenu = TabMenu;
const react_1 = __importDefault(require("react"));
const useStyles_1 = require("~/useStyles");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    tabMenu: {
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
    },
    tabs: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        justifyContent: "space-around",
        backgroundColor: "#303030",
    },
    tab: {
        "flex": 1,
        "padding": "6px 12px",
        "cursor": "pointer",
        "borderBottom": "2px solid transparent",
        "fontFamily": theme.typography.primary,
        "fontOpticalSizing": "auto",
        "fontWeight": 700,
        "fontStyle": "normal",
        "fontSize": "14px",
        "color": "#e8e8e8",
        "@media (min-width: 400px)": {
            padding: "10px 20px",
            fontSize: "18px",
        },
        "&.active": {
            background: "#797979",
            fontWeight: "bold",
            color: "#242424",
        },
    },
    content: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        padding: "0.5em",
    },
}));
function TabMenu({ tabs, className }) {
    const classes = useStyles();
    const [activeTab, setActiveTab] = react_1.default.useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    return (react_1.default.createElement("div", { className: `${classes.tabMenu} ${className}` },
        react_1.default.createElement("ul", { className: classes.tabs }, tabs.map((tab, index) => (react_1.default.createElement("li", { key: index, className: `${classes.tab} ${activeTab === index ? "active" : ""}`, onClick: () => handleTabClick(index) }, tab.label)))),
        react_1.default.createElement("div", { className: classes.content }, tabs[activeTab].content)));
}
